import { Button, Divider, Form, Modal, Row, Select, Space } from 'antd';
import React, { useRef, useState } from 'react'
import { fetchData, saveData } from '../../service/dataServices';
import {
  PlusOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import TranslatableInput from './TranslatableInput';
import { getLocalizedTitle } from '../../utils/localization';
const { Option } = Select;


function DropdownFormItem({ options, type, label, rootFieldName, multiple, hasWritePermission, disabled }) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [inputValue, setInputValue] = useState({ en: '', ar: '' });

  const saveMutation = saveData('/api/dropdowns', 'POST');

  const showAddModal = () => {
    setShowModal(true);
  }

  const addItem = e => {
    e.preventDefault();
    showAddModal();
  };

  const onModalOk = () => {
    setShowModal(false);
    if (inputValue.en && inputValue.en.length > 0) {
      const translations = {
        en: inputValue.en,
        ar: inputValue.ar || '',
      };
      // Remove empty translations
      Object.keys(translations).forEach(k => {
        if (!translations[k]) delete translations[k];
      });

      let dataToSend = {
        'title': inputValue.en,
        'translations': translations,
        'dropdownType': type,
      };
      saveMutation.mutate({ dataToSend });
    }
  };

  const popupRender = (menu) => (
    <>
      {menu}
      <Divider style={{ margin: '8px 0' }} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
          Add item
        </Button>
      </div>
    </>
  )

  return (
    <>
      <Form.Item label={label} name={[rootFieldName, type]}>
        <Select
          showSearch
          filterOption
          optionFilterProp="children"
          placeholder={`${t("common.select")} ${label || type}`}
          disabled={!hasWritePermission || disabled}
          mode={multiple ? 'multiple' : false}
          allowClear
          popupRender={popupRender}
        >
          {
            options?.map(option => (
              <Option value={option.id} key={option.id}>{getLocalizedTitle(option)}</Option>
            ))
          }
        </Select>
      </Form.Item>
      <Modal
        title={`Add ${label} Dropdown`}
        open={showModal}
        onCancel={() => setShowModal(false)}
        onOk={onModalOk}
        closable={false}
        destroyOnHidden
        centered
        width={700}
      >
        <Space direction="vertical" align="stretch" style={{ display: 'flex' }}>
          <div style={{ width: '100%' }}>
            <TranslatableInput
              value={inputValue}
              onChange={setInputValue}
              placeholder={{ en: 'Dropdown value (English)', ar: 'قيمة القائمة المنسدلة (عربي)' }}
            />
          </div>
        </Space>
      </Modal>
    </>
  )
}

export default function useDropdownFormItemHook(hasWritePermission) {
  const [dropdowns, setDropdowns] = useState([]);
  fetchData('/api/dropdowns', setDropdowns);

  const getDropdownOptions = (type) => {
    if (dropdowns) {
      return dropdowns[type];
    }
    return [];
  };

  const singleSelectFormItem = function single(type, label, disabled = false) {
    return <DropdownFormItem
      options={getDropdownOptions(type)}
      type={type}
      label={label}
      hasWritePermission={hasWritePermission}
      disabled={disabled}
      rootFieldName='dropdowns'
      multiple={false}
    />
  }
  const multiSelectFormItem = function multi(type, label, disabled = false) {
    return <DropdownFormItem
      options={getDropdownOptions(type)}
      type={type}
      label={label}
      hasWritePermission={hasWritePermission}
      disabled={disabled}
      rootFieldName='multiSelects'
      multiple={true}
    />
  }
  return { singleSelectFormItem, multiSelectFormItem };
}